import reduceReducers from 'reduce-reducers';

import { appEventTypes } from 'events/app';
import { userEventTypes } from 'events/user';
import initialState from 'reducers/initialStates/user';

export const updateUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case appEventTypes.AUTHENTICATION_SUCCESS:
    case userEventTypes.USER_UPDATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export const createUserReducer = (state = {}, action) => {
  switch (action.type) {
    case userEventTypes.USER_CREATE:
    case userEventTypes.USER_CREATE_SUCCESS:
    case appEventTypes.AUTHENTICATION_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default reduceReducers(updateUserReducer, createUserReducer);
